"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sources = require("@studio/sources");
var _program = require("@studio/program");
var _constants = require("@studio/constants");
var _ = require("./..");
var _sources2 = require("../../utils/sources");
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function toggleSourceProgram(source, setProgram) {
  return function (dispatch, getState) {
    var _getState = getState(),
      sceneLayout = _getState.sceneLayout,
      sceneLayers = _getState.sceneLayers,
      banners = _getState.banners,
      backgrounds = _getState.backgrounds,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      broadcastSources = _getState.broadcastSources,
      program = _getState.program,
      brandingSettings = _getState.brandingSettings;
    var layers = (0, _program.getProgramLayers)(program);
    var scene = null;
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    // Check if source exists in program layer
    var layerSource = layers.find(function (layer) {
      return layer.source._id === source._id;
    });
    var sources = (0, _sources2.getBroadcastSourcesFromLayers)(layers, broadcastSources.sources);

    /**
     * Get new scene layout based on the source type
     * If source type is audio, don't change scene layout
     */
    var isPresenterSource = (0, _sources.isCameraPresenter)(source);
    var newSceneLayout = (0, _sources.isAudioSource)(source) ? sceneLayout : (0, _program.selectSceneLayout)(sceneLayout, source, sources);
    var withAudioPresenterSources = (0, _sources.attachAudioPresenterSources)(sources, attendeeMuteStatus);

    // If layer source exist, remove it from program sources
    if (layerSource) {
      var newSources = withAudioPresenterSources.filter(function (source) {
        return source._id !== layerSource.source._id;
      });
      scene = (0, _program.sceneBuilder)(newSceneLayout, newSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
    } else {
      // source does not exist, add it to program.
      if ((0, _sources2.willExceedCameraLimit)(sources, source)) {
        // we will not change the scene since we are on the limit but only display notification to inform the user that the limit is attained.
        dispatch((0, _.showNotification)("You're at the max of ".concat(_constants.CAMERA_PRESENTER_LIMIT, " sources available at a time in program."), {
          timeout: 3500,
          type: 'alert'
        }));
      } else {
        var combinedSources = (0, _sources2.combineSources)(sources, source);
        var orderedSources = isPresenterSource ? combinedSources.sort(function (a, b) {
          return a.order - b.order;
        }) : combinedSources;
        var _withAudioPresenterSources = (0, _sources.attachAudioPresenterSources)(orderedSources, attendeeMuteStatus);
        scene = (0, _program.sceneBuilder)(newSceneLayout, _withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
      }
    }
    var currentBackground = backgrounds.find(function (b) {
      var _program$style;
      return b._id === (program === null || program === void 0 || (_program$style = program.style) === null || _program$style === void 0 ? void 0 : _program$style.backgroundId) && b.source.hidden === false;
    });
    if (scene) {
      var _scene;
      scene = _objectSpread(_objectSpread({}, scene), {}, {
        style: currentBackground ? program === null || program === void 0 ? void 0 : program.style : (_scene = scene) === null || _scene === void 0 ? void 0 : _scene.style
      });
      dispatch(setProgram(scene));
      (0, _sendToDatadogWithIds.logProgramChange)(getState, 'toggleProgramSource action');
      dispatch((0, _.setSceneLayout)(newSceneLayout));
    }
  };
}
var _default = exports["default"] = toggleSourceProgram;